<template>
  <div
    v-if="isVisible"
    class="form-error-list"
  >
    <ul class="list form-error-list__items">
      <li
        v-for="(message, i) in messages"
        :key="i"
        class="list__element list__element--dashed form-error-list__item"
      >
        <div v-html="message"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import { forIn, isArray, flattenDeep, uniq } from 'lodash-es';

function collectMessages(messages) {
  const collectedMessages = [];
  if (!isArray(messages)) {
    forIn(messages, (message) => {
      collectedMessages.push(collectMessages(message));
    });
  } else {
    collectedMessages.push(messages);
  }
  return uniq(flattenDeep(collectedMessages));
}

export default {
  name: 'FormErrorList',
  props: {
    errors: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isVisible() {
      return this.messages.length > 0;
    },
    messages() {
      return collectMessages(this.errors);
    },
  },
};
</script>

<style lang="scss">
@use 'assets/base' as *;

.form-error-list {
  width: 100%;
  padding-top: 1.5 * $grid-base;
  padding-bottom: 1.5 * $grid-base;
  @include mq($mq-sm) {
    padding-top: 2.5 * $grid-base;
    padding-bottom: 2.5 * $grid-base;
  }

  &__items {
    display: flex;
    flex-direction: column;
    &--center {
      align-items: center;
    }
    &--right {
      align-items: flex-end;
    }
    &--left {
      align-items: flex-start;
    }
  }

  &__item {
    color: var(--color-error);
    padding-bottom: 0;
  }
}
</style>
